export enum PromotionType {
    SPA = 'spa',
    OLO = 'olo',
}

export interface IPromotion {
    id: number | string,
    uniqueId: number,
    type: PromotionType,
    productName: string,
    productImage: string,
    productDescription: string,
    price: string,
    saleEndDate: string,
    productUpc: string,
    itemId: string,
    ingredientId: number,
    baseIngredientId: number,
    maxOffers: number,
}
